var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',_vm._l((_vm.headers),function(header,i){return _c('col',{key:i + 'column',style:({
      width: header.width + 'px'
    })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }